import Symbol from "./Symbol";
import { INSPECTOR_FUSE } from "../../../constants/inspectorConstants";

// Fusibles
class Fuse extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name, variants}) {
        super("Fuse", { alias, svgSrc, label, rotable, handles, name, variants });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            ratedVoltage: { isVisible: false, value: null, label: "Voltaje nominal" },
            phaseCount: { isVisible: false, value: null, label: "Número de fases" },
            ratedCurrent: { isVisible: false, value: null, label: "Corriente nominal" },
            breakingCapacity: { isVisible: false, value: null, label: "Capacidad interruptiva" },
        };   
        this.rotable = rotable;
    }

    getInspector() {
        return INSPECTOR_FUSE;
    }
}

export default Fuse;
